var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_night") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1103,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE-\\u6DF1\\u8272",
    transform: "translate(-144.000000, -81.000000)",
    fill: "#00cfff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_night",
    transform: "translate(144.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0000238,0 L12.3012227,0.00600206514 L12.3012227,0.00600206457 C12.4918632,0.015348364 12.6388323,0.177469716 12.6294863,0.368111297 C12.6262675,0.433766552 12.6043912,0.497142277 12.5664239,0.550802787 C11.9292242,1.44840337 11.5404243,2.06280219 11.3988234,2.39640112 L11.3988234,2.39640112 C9.7381666,6.37124956 11.6141998,10.9397603 15.589053,12.6004002 C17.3920617,13.3536802 19.412139,13.402778 21.2496008,12.7379868 L21.5808007,12.6107868 C22.0223996,12.4271869 22.5756012,12.094786 23.2404,11.6123862 L23.2404,11.6123862 C23.4545845,11.4573048 23.7539342,11.5052171 23.9090154,11.7194015 C23.968115,11.8010245 24,11.8992136 24,11.999986 C24,12.2699859 23.9916,12.5387848 23.9736,12.8039866 L23.9412,13.1999865 L23.9172,13.4159864 L23.8692,13.7783853 C23.0100012,19.5623736 18.0228023,24 12,24 C5.37240726,24 0,18.6275834 0,11.999986 C0,6.08757895 4.27679831,1.17358089 9.90480547,0.182400031 L10.3092062,0.11880015 L10.5936061,0.0816000709 L10.8000061,0.0588000706 C11.1948051,0.0204001795 11.5944049,0 12,0 L12.0000238,0 Z M8.68802509,2.9867915 L8.48762526,3.06239147 L8.48762572,3.06239129 C3.55351829,5.00817927 1.13100049,10.5854321 3.0767716,15.5195676 C4.52223572,19.1849568 8.05990089,21.5955777 12.000015,21.5999933 L12.0000144,21.5999933 C16.0256003,21.5999933 19.6238833,19.0890534 21.0132015,15.3107958 L21.0132015,15.3107958 C15.5400785,16.6445503 10.0219838,13.2889185 8.68824062,7.81579568 C8.30164015,6.22935505 8.30155858,4.57329383 8.68800557,2.9867915 L8.68802509,2.9867915 Z",
    id: "\\u5F62\\u72B6",
    transform: "translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDark);
export default __webpack_public_path__ + "static/media/ic_dark.ab63e401607ec5f40ca3139be0940a55.svg";
export { ForwardRef as ReactComponent };